const UNKNOWN_LOCATION_IDS = new Set(['unknown', 'unknown-needs-mapping', 'unknown_needs_mapping']);
const SAME_LOCATION_RADIUS_METERS = 150;

const locationIds = (incident = {}) => {
  const raw = [
    incident?.map_projection?.location_id,
    ...(Array.isArray(incident?.location) ? incident.location : [incident?.location]),
  ];
  return new Set(raw
    .map((value) => String(value || '').trim())
    .filter((value) => value && !UNKNOWN_LOCATION_IDS.has(value.toLowerCase())));
};

const incidentPoint = (incident = {}) => {
  const value = incident?.map_projection?.official_coordinates
    || incident?.map_projection?.coordinates
    || incident?.gps_coordinates;
  const lat = Number(value?.latitude ?? value?.lat ?? incident?.gps_latitude);
  const lng = Number(value?.longitude ?? value?.lng ?? incident?.gps_longitude);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

const pointDistanceMeters = (left, right) => {
  if (!left || !right) return Number.POSITIVE_INFINITY;
  const radius = 6371000;
  const toRadians = (value) => value * (Math.PI / 180);
  const dLat = toRadians(right.lat - left.lat);
  const dLng = toRadians(right.lng - left.lng);
  const lat1 = toRadians(left.lat);
  const lat2 = toRadians(right.lat);
  const a = Math.sin(dLat / 2) ** 2
    + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const incidentsShareLocation = (left, right) => {
  const leftIds = locationIds(left);
  const rightIds = locationIds(right);
  if ([...leftIds].some((id) => rightIds.has(id))) return true;
  return pointDistanceMeters(incidentPoint(left), incidentPoint(right)) <= SAME_LOCATION_RADIUS_METERS;
};

export const relatedOrSameLocationIncidents = (incidents = [], incident = {}) => {
  if (incident?.is_scenario) return [];
  const currentId = String(incident?.id || '');
  const parentId = String(incident?.parent_incident_id || '');
  const currentIsExercise = incident?.is_exercise === true;
  const seen = new Set();
  return (Array.isArray(incidents) ? incidents : []).filter((candidate) => {
    const candidateId = String(candidate?.id || '');
    if (
      !candidateId
      || candidateId === currentId
      || candidate?.is_active === false
      || candidate?.is_scenario
      || candidate?.is_planned_event
    ) return false;
    if ((candidate?.is_exercise === true) !== currentIsExercise) return false;
    const directlyRelated = String(candidate?.parent_incident_id || '') === currentId
      || (parentId && candidateId === parentId);
    if (!directlyRelated && !incidentsShareLocation(incident, candidate)) return false;
    if (seen.has(candidateId)) return false;
    seen.add(candidateId);
    return true;
  });
};

export const incidentLocationLabel = (incident = {}) => incident?.map_projection?.location_name
  || (Array.isArray(incident?.location_names) ? incident.location_names.find(Boolean) : null)
  || '';
